import React, { useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { NavLink, useNavigate } from "react-router-dom";
import Papa from "papaparse";
import axios from "axios";
import mime from "mime";
import GLOBALS from "../../utils/Globals";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Badge from "react-bootstrap/Badge";


var filename = "";
const maxLength = 40;
var filename = "";
const allowedExtensions = ["csv"];
var mts = "";
var username = "";

const toastCancelImport = () => toast.warning("This file format is not supported");

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#353b48",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

// function nameLengthValidator(file) {
//   //console.log(file.name);
//   const inputFile = file.name;
//   filename = file.name;

//   const formData = new FormData();
//   formData.append("file", file);

//   const reader = new FileReader();
//   reader.onload = async ({ target }) => {
//     const csv = Papa.parse(target.result, {
//       header: true,
//     });
//     const parsedData = csv?.data;
//     const rows = Object.keys(parsedData[0]);

//     const columns = Object.values(parsedData[0]);
//     const res = rows.reduce((acc, e, i) => {
//       return [...acc, [[e], columns[i]]];
//     }, []);
//   };
//   reader.readAsText(file);
//   if (filename.indexOf(" ") >= 0) {
//     return {
//       code: "name-too-large",
//       message: `Filename has spaces in it`,
//     };
//   }

//   return null;
// }

function nameLengthValidator(file) {
  //console.log(file.name);
  const inputFile = file.name;
  filename = file.name;

  const newFilename = filename.replace(/ /g, "_");

  filename = newFilename

  username = localStorage.getItem("userInfo");

  const obj = JSON.parse(username);
  //console.log(obj.userFound.email);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("username", obj.userFound.email);

  const fileType = "";
  var mime_type_sel = "";

  const mimeType = mime.getType(file.name);  
  console.log("File MIME type:", mimeType);
  if (mimeType == "application/pdf") {
    //console.log("pdf");
    mts = "pdf";

    // TODO PDF
  } else if (mimeType == "text/csv") {
    //console.log("csv");
    mts = "csv";

    // upload the file to flask server
    // TODO upload to AWS s3
    axios
      .post(GLOBALS.DEV.dropMeJobs, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // handle the response
        // console.log(response.data);
        // console.log(response.data.uid);
        // console.log(response.data._id);
        localStorage.setItem("manuuid", response.data.uid);
        localStorage.setItem("tuid", response.data.uid);
        //localStorage.setItem("_id", response.data._id);
      })
      .catch((error) => {
        // handle errors
        console.log(error);
      });

    // check for headers
    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      const csv = Papa.parse(target.result, {
        header: true,
      });
      const parsedData = csv?.data;
      const rows = Object.keys(parsedData[0]);

      const columns = Object.values(parsedData[0]);
      const res = rows.reduce((acc, e, i) => {
        return [...acc, [[e], columns[i]]];
      }, []);
    };
  } else if (
    mimeType ==
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ) {
    //console.log("xlsx");
    mts = "xlsx";

    // upload the file to flask server
    // TODO upload to AWS s3
    axios
      .post(GLOBALS.DEV.dropMeJobsXLSX, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // handle the response
        // console.log(response.data);
        // console.log(response.data.uid);
        // console.log(response.data._id);
        localStorage.setItem("manuuid", response.data.uid);
        localStorage.setItem("tuid", response.data.uid);
        //localStorage.setItem("_id", response.data._id);
      })
      .catch((error) => {
        // handle errors
        console.log(error);
      });
  } else if (mimeType == "application/vnd.ms-excel") {
    //console.log("xls");
    mts = "xls";

    // TODO XLS
  } else {
    console.log("other");
    toastCancelImport()
    
  }

  return null;
}


export default function StyledDropzone(props) {

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    multiple: false,
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
      "text/csv": [],
      "application/pdf": [],
      "text/plain": []
    },
    validator: nameLengthValidator,
  });

  const acceptedFileItems = acceptedFiles.map((file) => (
    <>
      <Badge bg="success">Success</Badge>&nbsp;&nbsp;Ready to import file -{" "}
      {file.path} &nbsp;{file.size} bytes
      {/* {file.size} bytes
      {file.path}
      <li key={file.path}>
        {file.path} - {file.size} bytes
      </li> */}
    </>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <>
      <Badge bg="danger">Rejected</Badge>
      <li key={file.path}>
        {file.path} - {file.size} bytes
        <ul>
          {errors.map((e) => (
            <li key={e.code}>{e.message}</li>
          ))}
        </ul>
      </li>
    </>
  ));

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <div className="container">
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <div style={{ textAlign: "center " }}>
          <p>Drop your file here, or browse</p>
          <p style={{ fontSize: "0.8rem" }}>
            Supports CSV, XLSX, PDF and Excel files
          </p>
        </div>
      </div>
      <aside>
        &nbsp;&nbsp;&nbsp;
        {acceptedFileItems.length > 0 ? null : null}
        {acceptedFileItems.length > 0 ? <h4>{acceptedFileItems}</h4> : null}
        {fileRejectionItems.length > 0 ? null : null}
        {fileRejectionItems.length > 0 ? <h4>{fileRejectionItems}</h4> : null}
      </aside>
      {localStorage.setItem("manufile", filename)}
      <br></br>
      {acceptedFileItems.length > 0 && (
        <NavLink to="/import_document_gln">
          <button
            type="submit"
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
          >
            CONTINUE
          </button>
        </NavLink>
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
